module.exports = __webpack_public_path__ + "img/131.cf5cae95.jpg";